import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(consumer)/_authenticated/bookings/$id/payment'
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/bookings/$id',
      params: { id: params.id },
      search: { ref: 'bookings' },
    });
  },
});
